var map = {
	"./5th-element-circle-entrances-slider.svg": 964,
	"./5th-element-circle-header.svg": 707,
	"./5th-element-circle-testimonial.svg": 447,
	"./5th-element-circle-textimage.svg": 139,
	"./5th-element-lineleft-entrances.svg": 998,
	"./5th-element-lineleft-testimonial.svg": 887,
	"./5th-element-lineright-header-half.svg": 630,
	"./5th-element-lineright-header.svg": 822,
	"./5th-element-lineright-textimage.svg": 100,
	"./5th-element-wave-entrances.svg": 900,
	"./5th-element-wave-textimage.svg": 5,
	"./arrow-btn.svg": 420,
	"./arrow.svg": 503,
	"./checkmark.svg": 849,
	"./facebook.svg": 364,
	"./instagram.svg": 563,
	"./linkedin.svg": 785,
	"./logo-minified.svg": 9,
	"./logo.svg": 860,
	"./play.svg": 873,
	"./search.svg": 48,
	"./user.svg": 396,
	"./youtube.svg": 492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;